import React from "react";



export default function FinancingControls({ settings, onChange }) {
  const { loanType, holdPeriod, targetROI, scenario } = settings;

  const loanTypes = [
    { id: "conventional", label: "Conventional 30yr" },
    { id: "arm", label: "5/1 ARM" },
    { id: "cash", label: "All Cash" },
    { id: "fha", label: "FHA 3.5%" },
  ];

  const scenarios = [
    { id: "base", label: "Base Case" },
    { id: "optimistic", label: "Optimistic" },
    { id: "pessimistic", label: "Pessimistic" },
  ];

  return (
    <div className="card-base flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6">
      {/* Financing Type */}
      <div className="flex flex-col gap-1.5 min-w-0">
        <label className="text-xs font-caption font-medium text-muted-foreground uppercase tracking-wide">
          Financing Option
        </label>
        <div className="flex flex-wrap gap-2">
          {loanTypes?.map((lt) => (
            <button
              key={lt?.id}
              onClick={() => onChange("loanType", lt?.id)}
              className={`px-3 py-1.5 rounded-lg text-xs font-caption font-medium border transition-standard ${
                loanType === lt?.id
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              {lt?.label}
            </button>
          ))}
        </div>
      </div>
      <div className="hidden lg:block w-px h-10 bg-border" />
      {/* Hold Period */}
      <div className="flex flex-col gap-1.5 min-w-[180px]">
        <label className="text-xs font-caption font-medium text-muted-foreground uppercase tracking-wide">
          Hold Period:{" "}
          <span className="text-primary font-semibold">{holdPeriod} yrs</span>
        </label>
        <input
          type="range"
          min={1}
          max={30}
          value={holdPeriod}
          onChange={(e) => onChange("holdPeriod", Number(e?.target?.value))}
          className="w-full accent-primary h-2 rounded-full cursor-pointer"
        />
        <div className="flex justify-between text-xs text-muted-foreground font-caption">
          <span>1yr</span>
          <span>30yr</span>
        </div>
      </div>
      <div className="hidden lg:block w-px h-10 bg-border" />
      {/* Target ROI */}
      <div className="flex flex-col gap-1.5 min-w-[160px]">
        <label className="text-xs font-caption font-medium text-muted-foreground uppercase tracking-wide">
          Target ROI:{" "}
          <span className="text-primary font-semibold">{targetROI}%</span>
        </label>
        <input
          type="range"
          min={3}
          max={25}
          step={0.5}
          value={targetROI}
          onChange={(e) => onChange("targetROI", Number(e?.target?.value))}
          className="w-full accent-primary h-2 rounded-full cursor-pointer"
        />
        <div className="flex justify-between text-xs text-muted-foreground font-caption">
          <span>3%</span>
          <span>25%</span>
        </div>
      </div>
      <div className="hidden lg:block w-px h-10 bg-border" />
      {/* Scenario */}
      <div className="flex flex-col gap-1.5">
        <label className="text-xs font-caption font-medium text-muted-foreground uppercase tracking-wide">
          Scenario
        </label>
        <div className="flex gap-2">
          {scenarios?.map((s) => (
            <button
              key={s?.id}
              onClick={() => onChange("scenario", s?.id)}
              className={`px-3 py-1.5 rounded-lg text-xs font-caption font-medium border transition-standard ${
                scenario === s?.id
                  ? s?.id === "optimistic" ?"bg-success text-success-foreground border-success"
                    : s?.id === "pessimistic" ?"bg-accent text-accent-foreground border-accent" :"bg-primary text-primary-foreground border-primary" :"bg-background text-foreground border-border hover:bg-muted"
              }`}
            >
              {s?.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}